import React from 'react';
import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';

import phone_no from '../assets/images/icons/phone_no.svg';
import mail from '../assets/images/icons/mail.svg';


import Headermain from './Headermain';
import Footer from './Footer';



class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Contact</title>
                </Helmet>
                <Headermain prop={this.props} />
                <div className="content-wrapper full_width_section">
                    <div className="container">
                        <h4 className="contact-title">Contact</h4>
                        <div className="contact-sec">
                            <div className="contact-img">
                                <form action="#" className="contact-form">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group form-field text-left">
                                                <label for="" className="form-label"></label>
                                                <input id="text_field1" type="text" name="name" className="form-control" placeholder="Name" required="required" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group form-field text-left">
                                                <label for="" className="form-label"></label>
                                                <input id="text_field1" type="text" name="name" className="form-control" placeholder="Email Address" required="required" />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group form-field text-left">
                                                <label for="" className="form-label"></label>
                                                <input id="text_field" type="number" name="phone number" className="form-control" placeholder="Phone Number" required="required" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group form-field text-left">
                                                <label for="" className="form-label"></label>
                                                <input id="text_field1" type="text" name="subject" className="form-control" placeholder="Subject" required="required" />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-field form-group spacing text-left">
                                                <label for="" className="form-label"></label>
                                                <textarea className="txtArea form-control" id="message-box" rows="5" cols="50" placeholder="Message"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="top-sec">
                                                <a href="#" title="Send Message" className="send-btn">
                                                    Send Message
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="contact-text">
                                <div className="contact-info">
                                    <a itemprop="telephone" href="tel:+918407812606" title="+91 840 781 2606">
                                        <span><img src={phone_no} className="img-fluid" alt="contact" /></span>
                                        840 781 2606</a>
                                </div>
                                <div className="contact-info">
                                    <a itemprop="email" href="" title="PhleboIndia">
                                        <span><img src={mail} className="img-fluid" alt="mail" /></span>
                                        </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer prop={this.props} />
            </>
        );
    }
};

export default Contact;